import React, { useEffect, useState } from "react";

import axios from "axios";

import {
  FaTimes,
  FaSave,
  FaFileAlt,
  FaListAlt,
  FaCube,
  FaLandmark,
  FaShoppingCart,
  FaCog,
  FaCreditCard,
  FaInfoCircle,
} from "react-icons/fa";

import { useGlobalContext } from "../../../Context/GlobalContext";

const API_PREFIX = process.env.REACT_APP_URL_PREFIX || "";

const blankForm = (createdBy) => ({
  file_number: "",
  e_office_number: "",
  intimation_date: "",

  demand_number: "",
  demand_date: "",
  indent_date: "",
  demand_entry_date_udm: "",

  item_id: "",
  item_name: "",
  quantity: "",
  unit: "Nos",
  account_type: "ADDITIONAL_ACCOUNT",

  requirement_date: "",
  fund_availability_date: "",
  finance_vetting_status: "",

  finance_concurrence_date: "",
  approval_date: "",
  sanction_date: "",

  purchase_order_number: "",
  purchase_order_date: "",
  ordered_qty: "",

  received_date: "",
  inspection_date: "",
  inspection_result: "PENDING",

  inspection_remarks: "",
  tpi_enabled: false,
  tpi_agency: "",
  tpi_date: "",
  tpi_remark: "",
  tpi_result: "",
  payment_type: "",
  payment_status: "NOT_STARTED",
  payment_date: "",

  current_status: "REQUIREMENT",
  pending_since: new Date().toISOString().slice(0, 10),

  remarks: "",
  created_by: createdBy || "central_depot",
});

const dateFields = [
  "intimation_date",
  "demand_date",
  "indent_date",
  "demand_entry_date_udm",

  "requirement_date",
  "fund_availability_date",
  "finance_concurrence_date",

  "approval_date",
  "sanction_date",
  "purchase_order_date",
  "received_date",

  "inspection_date",
  "tpi_date",
  "payment_date",
  "pending_since",
];

const numericFields = new Set(["quantity", "ordered_qty"]);

function normalizeFormData(source, createdBy) {
  const next = { ...blankForm(createdBy), ...(source || {}) };

  // HTML date inputs require YYYY-MM-DD; APIs often return ISO timestamps.

  dateFields.forEach((field) => {
    const value = next[field];

    next[field] = value ? String(value).slice(0, 10) : "";
  });

  return next;
}

const css = `

.sd-modal-backdrop{position:fixed;inset:0;background:rgba(12,27,47,.58);z-index:1100;display:flex;align-items:center;justify-content:center;padding:18px}

.sd-modal{background:#f7faff;width:min(1180px,97vw);max-height:94vh;overflow:auto;border-radius:14px;box-shadow:0 25px 70px #0004}

.sd-modal-head{display:flex;align-items:center;justify-content:space-between;gap:15px;padding:17px 22px;background:linear-gradient(110deg,#164a85,#0878ec);color:white;position:sticky;top:0;z-index:5}

.sd-modal-title{font-size:23px;font-weight:800;margin:0}.sd-modal-subtitle{font-size:13px;opacity:.88;margin-top:3px}

.sd-modal-close{border:0;background:#ffffff22;color:white;font-size:26px;border-radius:8px;width:40px;height:40px}

.sd-form-body{padding:16px 20px;display:grid;grid-template-columns:1fr 1fr;gap:14px}

.sd-form-section{background:white;border:1px solid #dce7f4;border-radius:10px;overflow:hidden}

.sd-form-section.payment-gem{border-color:#a8d9b0;background:#fbfffb;box-shadow:0 0 0 1px #d9f0dd inset}
.sd-form-section.tpi-active{border-color:#75c98a;background:#f4fff6;box-shadow:0 0 0 2px #d9f4df inset}
.sd-form-section.tpi-active .sd-form-section-head{background:#e6f8e9;color:#17652b;border-bottom-color:#bde7c5}
.sd-tpi-toggle{margin-left:auto;display:inline-flex;align-items:center;gap:9px;padding:8px 12px;border:1px solid #cbd5e1;border-radius:8px;background:#fff;color:#263953;font-weight:800;cursor:pointer;white-space:nowrap}
.sd-tpi-toggle input{width:18px;height:18px;margin:0;accent-color:#16a34a}
.sd-form-section.tpi-active .sd-tpi-toggle{border-color:#83ce92;background:#f0fff2;color:#17652b}

.sd-form-section.payment-ipass{border-color:#b7d0f5;background:#fbfdff;box-shadow:0 0 0 1px #dce9fb inset}

.sd-payment-methods{display:flex;gap:18px;flex-wrap:wrap;padding:14px 15px 4px}

.sd-payment-choice{display:inline-flex;align-items:center;gap:9px;padding:10px 14px;border:1px solid #d3deeb;border-radius:8px;background:#fff;color:#263953;font-weight:750;cursor:pointer}

.sd-payment-choice input{width:17px;height:17px;accent-color:#0875f9;margin:0}

.sd-payment-choice.gem-active{border-color:#9bd3a5;background:#f0fbf2;color:#236b31}

.sd-payment-choice.ipass-active{border-color:#a9c8f5;background:#eff6ff;color:#245aa6}

.sd-form-section.full{grid-column:1/-1}

.sd-form-section-head{display:flex;align-items:center;gap:10px;padding:11px 15px;background:#eaf3ff;color:#173f79;font-weight:800;border-bottom:1px solid #dce7f4}

.sd-form-section-head svg{color:#0875f9}

.sd-form-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:11px;padding:13px 15px}

.sd-form-grid.four{grid-template-columns:repeat(4,minmax(0,1fr))}

.sd-form-field{min-width:0}.sd-form-field.span2{grid-column:span 2}.sd-form-field.span3{grid-column:span 3}

.sd-form-field label{display:block;font-size:12px;font-weight:650;color:#405777;margin-bottom:5px}

.sd-form-field label .required{color:#e11d48}

.sd-form-field input,.sd-form-field select,.sd-form-field textarea{width:100%;border:1px solid #d3deeb;border-radius:7px;background:#fff;color:#263953;padding:9px 10px;min-height:39px;outline:none}

.sd-form-field input:focus,.sd-form-field select:focus,.sd-form-field textarea:focus{border-color:#70adff;box-shadow:0 0 0 3px #0b76f51a}

.sd-form-field input:disabled,.sd-form-field select:disabled,.sd-form-field textarea:disabled{background:#e9ecef!important;color:#6b7280!important;border-color:#d1d5db!important;cursor:not-allowed;opacity:1;box-shadow:none}

.sd-form-field textarea{min-height:76px;resize:vertical}

.sd-form-footer{display:flex;justify-content:flex-end;gap:10px;padding:14px 20px;border-top:1px solid #dce7f4;background:white;position:sticky;bottom:0;z-index:5}

.sd-cancel{border:1px solid #cbd7e5;background:#f0f4f8;color:#36506d;border-radius:8px;padding:10px 17px;font-weight:700}

.sd-save{border:1px solid #0875f9;background:#0875f9;color:white;border-radius:8px;padding:10px 18px;font-weight:750;display:inline-flex;align-items:center;gap:8px}

.sd-save:disabled{opacity:.6;cursor:wait}

.sd-form-error{margin:12px 20px 0;padding:10px 13px;background:#fff0f0;border:1px solid #ffd2d2;color:#a51f1f;border-radius:7px}

.sd-confirm-backdrop{position:fixed;inset:0;background:rgba(8,20,38,.58);z-index:1300;display:flex;align-items:center;justify-content:center;padding:18px}

.sd-confirm-card{width:min(430px,94vw);background:#fff;border-radius:13px;padding:23px;box-shadow:0 20px 65px #0004;color:#263953}

.sd-confirm-card h3{font-size:19px;margin:0 0 9px;color:#173a69}

.sd-confirm-card p{font-size:14px;line-height:1.55;color:#64748b;margin:0 0 20px}

.sd-confirm-actions{display:flex;justify-content:flex-end;gap:9px}

.sd-confirm-update{border:1px solid #0875f9;background:#0875f9;color:#fff;border-radius:8px;padding:10px 15px;font-weight:750}

@media(max-width:800px){.sd-form-body{grid-template-columns:1fr;padding:10px}.sd-form-section.full{grid-column:auto}.sd-form-grid,.sd-form-grid.four{grid-template-columns:repeat(2,minmax(0,1fr))}.sd-form-field.span3{grid-column:span 2}.sd-modal-title{font-size:19px}}

@media(max-width:450px){.sd-form-grid,.sd-form-grid.four{grid-template-columns:1fr}.sd-form-field.span2,.sd-form-field.span3{grid-column:auto}.sd-modal-backdrop{padding:5px}.sd-modal{max-height:98vh}}

`;

function Field({
  label,
  name,
  value,
  onChange,
  type = "text",
  options,
  required = false,
  span = 1,
  placeholder = "",
  disabled = false,
}) {
  return (
    <div
      className={`sd-form-field ${span === 2 ? "span2" : span === 3 ? "span3" : ""}`}
    >
      <label htmlFor={`sd-${name}`}>{label}</label>

      {options ? (
        <select
          id={`sd-${name}`}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          disabled={disabled}
        >
          <option value="">Select {label.toLowerCase()}</option>

          {options.map((o) =>
            typeof o === "string" ? (
              <option key={o} value={o}>
                {o.replaceAll("_", " ")}
              </option>
            ) : (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ),
          )}
        </select>
      ) : (
        <input
          id={`sd-${name}`}
          name={name}
          type={type}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          step={type === "number" ? "any" : undefined}
          disabled={disabled}
        />
      )}
    </div>
  );
}

function Section({ title, icon, children, full = false }) {
  return (
    <section className={`sd-form-section ${full ? "full" : ""}`}>
      <div className="sd-form-section-head">
        {icon}
        {title}
      </div>

      {children}
    </section>
  );
}

export default function InitiateProcurement({
  mode = "create",
  data = null,
  onClose = () => {},
  onSuccess = () => {},
  createdBy,
}) {
  const { userData } = useGlobalContext();

  const [form, setForm] = useState(() =>
    normalizeFormData(data, createdBy || userData?.id),
  );

  const [itemMaster, setItemMaster] = useState([]);

  const [itemsLoading, setItemsLoading] = useState(false);

  const [itemsError, setItemsError] = useState("");

  const [saving, setSaving] = useState(false);

  const [error, setError] = useState("");

  const [showUpdateConfirm, setShowUpdateConfirm] = useState(false);

  const isEdit = mode === "edit" && Boolean(data?.case_id);

  // Load item names from the item master table for the Item Name dropdown.

  useEffect(() => {
    let cancelled = false;

    const loadItemMaster = async () => {
      setItemsLoading(true);

      setItemsError("");

      try {
        const response = await axios.get(
          `${API_PREFIX}allMasterData?table_name=m_store_item_master`,
        );

        const responseData =
          response?.data?.data ?? response?.data?.result ?? response?.data;

        const rows = Array.isArray(responseData)
          ? responseData
          : Array.isArray(responseData?.rows)
            ? responseData.rows
            : Array.isArray(responseData?.data)
              ? responseData.data
              : [];

        const normalizedItems = rows
          .map((item) => {
            const id =
              item.item_id ??
              item.id ??
              item.item_code ??
              item.store_item_id ??
              item.ID;

            const name =
              item.item_name ??
              item.name ??
              item.item_description ??
              item.description ??
              item.item ??
              item.ITEM_NAME;

            return id != null && name != null
              ? { value: String(id), label: String(name), raw: item }
              : null;
          })
          .filter(Boolean);

        if (!cancelled) {
          setItemMaster(normalizedItems);

          if (!normalizedItems.length)
            setItemsError(
              "Item master API returned no recognizable item records. Check the response field names.",
            );
        }
      } catch (err) {
        if (!cancelled)
          setItemsError(
            err?.response?.data?.message ||
              err?.message ||
              "Could not load item master data.",
          );
      } finally {
        if (!cancelled) setItemsLoading(false);
      }
    };

    loadItemMaster();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const loadFormData = async () => {
      setForm(normalizeFormData(data, createdBy || userData?.id));

      setError("");

      setShowUpdateConfirm(false);

      if (mode !== "edit" || !data?.case_id) return;

      try {
        const response = await axios.get(
          `${API_PREFIX}store/procurements/${data.case_id}`,
        );

        const detail =
          response?.data?.data?.[0] || response?.data?.data || response?.data;

        if (!cancelled && detail && typeof detail === "object") {
          // Some API responses expose inspection information as a nested

          // TS_RR object or as sample_inspections instead of top-level fields.

          const inspectionList = Array.isArray(detail.sample_inspections)
            ? detail.sample_inspections
            : [];

          const latestInspection =
            detail.TS_RR ||
            detail.ts_rr ||
            detail.inspection ||
            inspectionList[inspectionList.length - 1] ||
            {};

          const mappedInspection = {
            // One visible date field represents both legacy TS&RR Submitted Date and Inspection Date.

            inspection_date:
              latestInspection.submitted_date ||
              latestInspection.inspection_date ||
              detail.submitted_date ||
              detail.inspection_date ||
              "",

            inspection_result:
              latestInspection.result ||
              latestInspection.inspection_result ||
              detail.inspection_result ||
              "PENDING",

            // One visible remarks field combines both legacy remarks fields.

            inspection_remarks:
              latestInspection.remarks ||
              detail.inspection_remarks ||
              detail.rejection_reason ||
              "",
            tpi_enabled: Boolean(
              latestInspection.TPI ||
              latestInspection.TPI_agency ||
              latestInspection.TPI_date ||
              latestInspection.TPI_remark ||
              latestInspection.TPI_result,
            ),
            tpi_agency:
              latestInspection.TPI_agency || latestInspection.tpi_agency || "",
            tpi_date:
              latestInspection.TPI_date || latestInspection.tpi_date || "",
            tpi_remark:
              latestInspection.TPI_remark || latestInspection.tpi_remark || "",
            tpi_result:
              latestInspection.TPI_result || latestInspection.tpi_result || "",
          };

          // Keep the form's Current Status and Remarks in sync with the latest

          // entry in Attachment History (history endpoint on procurement detail).

          const latestHistory = [
            ...(Array.isArray(detail.history) ? detail.history : []),
          ].sort((a, b) => {
            const dateA =
              new Date(a.action_date || a.created_at || 0).getTime() || 0;

            const dateB =
              new Date(b.action_date || b.created_at || 0).getTime() || 0;

            if (dateB !== dateA) return dateB - dateA;

            return Number(b.history_id || 0) - Number(a.history_id || 0);
          })[0];

          const historyStatus =
            latestHistory?.status_stage || latestHistory?.stage || "";

          const historyRemarks =
            latestHistory?.remarks ?? latestHistory?.action_remarks ?? "";

          setForm(
            normalizeFormData(
              {
                ...(data || {}),

                ...detail,

                // Read payment fields from the API; support camelCase date alias too.

                payment_type: (() => {
                  const rawType =
                    detail.payment_type ?? data?.payment_type ?? "";
                  const normalized = String(rawType).trim().toUpperCase();
                  return normalized === "GEM"
                    ? "GEM"
                    : ["I-PASS", "IPASS", "I_PASS"].includes(normalized)
                      ? "I-Pass"
                      : "";
                })(),

                payment_status:
                  detail.payment_status ??
                  data?.payment_status ??
                  "NOT_STARTED",

                payment_date:
                  detail.payment_date ??
                  detail.paymentDate ??
                  data?.payment_date ??
                  "",

                ...mappedInspection,

                ...(historyStatus ? { current_status: historyStatus } : {}),

                ...(latestHistory ? { remarks: historyRemarks } : {}),
              },

              createdBy || userData?.id,
            ),
          );
        }
      } catch (err) {
        if (!cancelled)
          setError(
            err?.response?.data?.message ||
              "Could not load complete demand details. You can still edit the available fields.",
          );
      }
    };

    loadFormData();

    return () => {
      cancelled = true;
    };
  }, [data, mode, createdBy, userData?.id]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape" && !saving) onClose();
    };

    window.addEventListener("keydown", onKeyDown);

    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose, saving]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "item_id") {
      const selectedItem = itemMaster.find((item) => item.value === value);

      setForm((prev) => ({
        ...prev,

        item_id: value,

        item_name: selectedItem ? selectedItem.label : prev.item_name,
      }));

      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: numericFields.has(name)
        ? value === ""
          ? ""
          : Number(value)
        : value,
    }));
  };

  const handlePaymentModeChange = (mode) => {
    setForm((prev) => ({
      ...prev,

      // The two options behave like checkbox choices, but only one payment route

      // is active at a time so the card has one unambiguous theme.

      payment_type: prev.payment_type === mode ? "" : mode,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setError("");

    if (isEdit) {
      setShowUpdateConfirm(true);

      return;
    }

    saveDemand();
  };

  const saveDemand = async () => {
    setError("");

    // TS&RR is optional when editing the main demand. Fields such as Quantity

    // can be updated even if this older record has no TS&RR Submitted Date.

    const hasTsRrData = Boolean(
      form.inspection_date ||
      (form.inspection_result && form.inspection_result !== "PENDING") ||
      form.inspection_remarks ||
      form.tpi_enabled ||
      form.tpi_agency ||
      form.tpi_date ||
      form.tpi_remark ||
      form.tpi_result,
    );

    setSaving(true);

    const payload = {
      ...form,

      // Use the active user's ID; do not hardcode a user ID.

      created_by:
        createdBy ??
        userData?.user_id ??
        userData?.id ??
        form.created_by ??
        "central_depot",

      // The updated POST/PUT/GET API supports these payment fields.

      payment_type: form.payment_type || null,

      payment_status: form.payment_status || "NOT_STARTED",

      payment_date: form.payment_date || null,
    };

    // Let the backend initialize system-managed defaults for new records.

    if (!isEdit) {
      delete payload.current_status;

      delete payload.pending_since;
    }

    // Convert blank fields to null so empty values can be submitted without client-side required-field blocking.

    Object.keys(payload).forEach((key) => {
      if (payload[key] === "") payload[key] = null;
    });

    try {
      if (isEdit) {
        delete payload.case_id;

        // These fields were removed from the UI; don't overwrite existing backend values with blanks.

        delete payload.received_qty;

        delete payload.accepted_qty;

        delete payload.rejected_qty;

        delete payload.item_rejection_date;

        delete payload.submitted_date;

        delete payload.rejection_reason;

        delete payload.history;

        delete payload.reminders;

        delete payload.documents;

        delete payload.sample_inspections;

        delete payload.created_at;

        delete payload.updated_at;

        delete payload.created_by;

        delete payload.pending_days;

        delete payload.last_action_stage;

        delete payload.last_action_date;

        delete payload.last_action_remarks;

        const updatePayload = {
          ...payload,

          payment_type: form.payment_type || null,

          payment_status: form.payment_status || "NOT_STARTED",

          payment_date: form.payment_date || null,

          updated_by: String(
            userData?.user_id || userData?.id || createdBy || "central_depot",
          ),
        };

        const updateResponse = await axios.put(
          `${API_PREFIX}store/procurements/${data.case_id}`,

          updatePayload,
        );

        if (
          updateResponse.data?.status === "error" ||
          updateResponse.data?.success === false
        ) {
          throw new Error(
            updateResponse.data?.message ||
              "Backend could not update the procurement entry.",
          );
        }

        // TS&RR inspection is stored through its dedicated endpoint, separately

        // from the main procurement record.

        if (hasTsRrData) {
          const inspectionPayload = {
            submitted_date: form.inspection_date || null,

            inspection_date: form.inspection_date || null,

            result: form.inspection_result || "PENDING",

            remarks: form.inspection_remarks || "",
            TPI: form.tpi_enabled ? true : null,
            TPI_agency: form.tpi_enabled ? form.tpi_agency || null : null,
            TPI_date: form.tpi_enabled ? form.tpi_date || null : null,
            TPI_remark: form.tpi_enabled ? form.tpi_remark || null : null,
            TPI_result: form.tpi_enabled ? form.tpi_result || null : null,

            created_by: String(userData?.id || createdBy || "central_depot"),
          };

          const inspectionResponse = await axios.post(
            `${API_PREFIX}store/procurements/${data.case_id}/TS_RR`,

            inspectionPayload,
          );

          if (
            inspectionResponse.data?.status === "error" ||
            inspectionResponse.data?.success === false
          ) {
            throw new Error(
              inspectionResponse.data?.message ||
                "Backend could not save the inspection details.",
            );
          }
        }
      } else {
        // Let the backend initialize system-managed fields for a new case.

        delete payload.current_status;

        delete payload.pending_since;

        const createResponse = await axios.post(
          `${API_PREFIX}store/create_procurement`,

          payload,
        );

        if (
          createResponse.data?.status === "error" ||
          createResponse.data?.success === false
        ) {
          throw new Error(
            createResponse.data?.message ||
              "Backend could not create the procurement entry.",
          );
        }
      }

      setShowUpdateConfirm(false);

      await onSuccess();
    } catch (err) {
      setShowUpdateConfirm(false);

      setError(
        err?.response?.data?.message ||
          err?.message ||
          `Failed to ${isEdit ? "update" : "save"} demand.`,
      );
    } finally {
      setSaving(false);
    }
  };

  const isGsdBhopal =
    String(form.account_type || "")
      .trim()
      .toUpperCase() === "GSD_BHOPAL";

  return (
    <>
      <style>{css}</style>

      <div
        className="sd-modal-backdrop"
        role="presentation"
        onMouseDown={(e) =>
          e.target === e.currentTarget && !saving && onClose()
        }
      >
        <form className="sd-modal" onSubmit={handleSubmit}>
          <header className="sd-modal-head">
            <div>
              <h2 className="sd-modal-title">
                {isEdit ? "View / Update Store Demand" : "Store Demand Entry"}
              </h2>
              <div className="sd-modal-subtitle">
                {isEdit
                  ? `Edit demand · ${data?.file_number || `Case #${data?.case_id}`}`
                  : "Create a new store demand for procurement"}
              </div>
            </div>

            <button
              type="button"
              className="sd-modal-close"
              onClick={onClose}
              disabled={saving}
              aria-label="Close"
            >
              <FaTimes />
            </button>
          </header>

          {error && <div className="sd-form-error">{error}</div>}

          <div className="sd-form-body">
            <Section title="Basic Information" icon={<FaFileAlt />} full>
              <div className="sd-form-grid four">
                <Field
                  label="File Number"
                  name="file_number"
                  value={form.file_number}
                  onChange={handleChange}
                  placeholder="STORE/2026/001"
                />

                <Field
                  label="E-Office Number"
                  name="e_office_number"
                  value={form.e_office_number}
                  onChange={handleChange}
                />

                <Field
                  label="Intimation Date"
                  name="intimation_date"
                  type="date"
                  value={form.intimation_date}
                  onChange={handleChange}
                />

                <Field
                  label="Demand Number"
                  name="demand_number"
                  value={form.demand_number}
                  onChange={handleChange}
                />
              </div>
            </Section>

            <Section title="Demand Details" icon={<FaListAlt />}>
              <div className="sd-form-grid">
                <Field
                  label="Demand Date"
                  name="demand_date"
                  type="date"
                  value={form.demand_date}
                  onChange={handleChange}
                />

                <Field
                  label="Indent Date"
                  name="indent_date"
                  type="date"
                  value={form.indent_date}
                  onChange={handleChange}
                />

                <Field
                  label="UDM Entry Date"
                  name="demand_entry_date_udm"
                  type="date"
                  value={form.demand_entry_date_udm}
                  onChange={handleChange}
                />
              </div>
            </Section>

            <Section title="Item Details" icon={<FaCube />}>
              <div className="sd-form-grid">
                <Field
                  label="Item Name"
                  name="item_id"
                  value={form.item_id == null ? "" : String(form.item_id)}
                  onChange={handleChange}
                  options={[
                    ...itemMaster,

                    ...(form.item_id &&
                    !itemMaster.some(
                      (item) => item.value === String(form.item_id),
                    )
                      ? [
                          {
                            value: String(form.item_id),
                            label: form.item_name
                              ? `${form.item_name} (current record)`
                              : `Item ID ${form.item_id} (current record)`,
                          },
                        ]
                      : []),
                  ]}
                  placeholder={
                    itemsLoading ? "Loading items..." : "Select item name"
                  }
                  span={3}
                />

                {itemsError && (
                  <div
                    className="sd-form-error"
                    style={{ margin: "0 15px 10px", gridColumn: "1 / -1" }}
                  >
                    {itemsError}
                  </div>
                )}

                <Field
                  label="Item ID"
                  name="item_id_display"
                  value={form.item_id}
                  onChange={() => {}}
                  disabled
                />

                <Field
                  label="Quantity"
                  name="quantity"
                  value={form.quantity}
                  onChange={handleChange}
                  type="number"
                />

                <Field
                  label="Unit"
                  name="unit"
                  value={form.unit}
                  onChange={handleChange}
                  options={[
                    "Nos",
                    "Kg",
                    "Meter",
                    "Litre",
                    "Set",
                    "Box",
                    "Pair",
                    "Roll",
                  ]}
                />

                <Field
                  label="Account Type"
                  name="account_type"
                  value={form.account_type}
                  onChange={handleChange}
                  options={[
                    {
                      value: "ADDITIONAL_ACCOUNT",
                      label: "Additional Account",
                    },

                    {
                      value: "REPLACEMENT_ACCOUNT",
                      label: "Replacement Account",
                    },

                    { value: "GSD_BHOPAL", label: "GSD Bhopal" },

                    { value: "OTHER", label: "Other" },
                  ]}
                  span={3}
                />
              </div>
            </Section>

            {!isGsdBhopal && (
              <>
                <Section
                  title="Finance & Approval Details"
                  icon={<FaLandmark />}
                >
                  <div className="sd-form-grid">
                    <Field
                      label="Requirement Date"
                      name="requirement_date"
                      type="date"
                      value={form.requirement_date}
                      onChange={handleChange}
                    />

                    <Field
                      label="Fund Availability Date"
                      name="fund_availability_date"
                      type="date"
                      value={form.fund_availability_date}
                      onChange={handleChange}
                    />

                    <Field
                      label="Finance Vetting Status"
                      name="finance_vetting_status"
                      value={form.finance_vetting_status}
                      onChange={handleChange}
                      options={[
                        "PENDING",
                        "VETTED",
                        "NOT_VETTED",
                        "NOT_REQUIRED",
                      ]}
                    />

                    <Field
                      label="Finance Concurrence Date"
                      name="finance_concurrence_date"
                      type="date"
                      value={form.finance_concurrence_date}
                      onChange={handleChange}
                    />

                    <Field
                      label="Approval Date"
                      name="approval_date"
                      type="date"
                      value={form.approval_date}
                      onChange={handleChange}
                    />

                    <Field
                      label="Sanction Date"
                      name="sanction_date"
                      type="date"
                      value={form.sanction_date}
                      onChange={handleChange}
                    />
                  </div>
                </Section>

                <Section
                  title="Purchase Order Details"
                  icon={<FaShoppingCart />}
                >
                  <div className="sd-form-grid">
                    <Field
                      label="Purchase Order Number"
                      name="purchase_order_number"
                      value={form.purchase_order_number}
                      onChange={handleChange}
                      span={2}
                    />

                    <Field
                      label="Purchase Order Date"
                      name="purchase_order_date"
                      type="date"
                      value={form.purchase_order_date}
                      onChange={handleChange}
                    />

                    <Field
                      label="Ordered Quantity"
                      name="ordered_qty"
                      type="number"
                      value={form.ordered_qty}
                      onChange={handleChange}
                    />
                  </div>
                </Section>

                <section
                  className={`sd-form-section ${form.tpi_enabled ? "tpi-active" : ""}`}
                >
                  <div className="sd-form-section-head">
                    <FaCog /> Inspection &amp; Receipt Details (TS&amp;RR)
                    <label className="sd-tpi-toggle">
                      <input
                        type="checkbox"
                        checked={Boolean(form.tpi_enabled)}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            tpi_enabled: event.target.checked,
                          }))
                        }
                      />
                      TPI
                    </label>
                  </div>
                  <div className="sd-form-grid">
                    <Field
                      label="Received Date"
                      name="received_date"
                      type="date"
                      value={form.received_date}
                      onChange={handleChange}
                    />
                    <Field
                      label="TS&RR Submitted / Inspection Date"
                      name="inspection_date"
                      type="date"
                      value={form.inspection_date}
                      onChange={handleChange}
                    />
                    <Field
                      label="Inspection Result"
                      name="inspection_result"
                      value={form.inspection_result}
                      onChange={handleChange}
                      options={["PENDING", "SATISFACTORY", "UNSATISFACTORY"]}
                    />
                    <Field
                      label="Rejection Reason / TS&RR Inspection Remarks"
                      name="inspection_remarks"
                      value={form.inspection_remarks}
                      onChange={handleChange}
                      span={3}
                    />
                    {form.tpi_enabled && (
                      <>
                        <Field
                          label="TPI Agency"
                          name="tpi_agency"
                          value={form.tpi_agency}
                          onChange={handleChange}
                        />
                        <Field
                          label="TPI Date"
                          name="tpi_date"
                          type="date"
                          value={form.tpi_date}
                          onChange={handleChange}
                        />
                        <Field
                          label="TPI Result"
                          name="tpi_result"
                          value={form.tpi_result}
                          onChange={handleChange}
                          options={[
                            "PENDING",
                            "SATISFACTORY",
                            "UNSATISFACTORY",
                            "APPROVED",
                            "REJECTED",
                          ]}
                        />
                        <Field
                          label="TPI Remark"
                          name="tpi_remark"
                          value={form.tpi_remark}
                          onChange={handleChange}
                          span={3}
                        />
                      </>
                    )}
                  </div>
                </section>

                <section
                  className={`sd-form-section ${form.payment_type === "GEM" ? "payment-gem" : form.payment_type === "I-Pass" ? "payment-ipass" : ""}`}
                >
                  <div className="sd-form-section-head">
                    <FaCreditCard />
                    Payment Details
                  </div>

                  <div
                    className="sd-payment-methods"
                    role="group"
                    aria-label="Payment route"
                  >
                    <label
                      className={`sd-payment-choice ${form.payment_type === "GEM" ? "gem-active" : ""}`}
                    >
                      <input
                        type="checkbox"
                        checked={form.payment_type === "GEM"}
                        onChange={() => handlePaymentModeChange("GEM")}
                      />
                      GEM
                    </label>

                    <label
                      className={`sd-payment-choice ${form.payment_type === "I-Pass" ? "ipass-active" : ""}`}
                    >
                      <input
                        type="checkbox"
                        checked={form.payment_type === "I-Pass"}
                        onChange={() => handlePaymentModeChange("I-Pass")}
                      />
                      I-Pass
                    </label>
                  </div>

                  {form.payment_type && (
                    <div className="sd-form-grid">
                      <Field
                        label="Payment Status"
                        name="payment_status"
                        value={form.payment_status}
                        onChange={handleChange}
                        options={["NOT_STARTED", "PAID", "NOT_APPLICABLE"]}
                        span={2}
                      />

                      <Field
                        label="Payment Date"
                        name="payment_date"
                        type="date"
                        value={form.payment_date}
                        onChange={handleChange}
                      />
                    </div>
                  )}
                </section>
              </>
            )}

            {/* In create mode, these system-managed fields appear blank.

              Their defaults remain in form state for the create API payload. */}

            <Section
              title="Current Status & Remarks"
              icon={<FaInfoCircle />}
              full
            >
              <div className="sd-form-grid">
                <Field
                  label="Current Status"
                  name="current_status"
                  value={isEdit ? form.current_status : ""}
                  onChange={handleChange}
                  disabled
                  options={[
                    "REQUIREMENT",
                    "APPROVAL",
                    "ACCOUNTS",
                    "FINANCE",

                    "PURCHASE_ORDER",
                    "INSPECTION",
                    "RECEIPT",
                    "STORE",

                    "PURCHASE",
                    "COMPLETED",
                    "REJECTED",
                    "TS_RR",
                  ]}
                />

                <Field
                  label="Pending Since"
                  name="pending_since"
                  type="date"
                  value={isEdit ? form.pending_since : ""}
                  onChange={handleChange}
                  disabled
                />

                <Field
                  label="Created By"
                  name="created_by"
                  value={form.created_by}
                  onChange={handleChange}
                  disabled
                />

                <Field
                  label="Remarks"
                  name="remarks"
                  value={isEdit ? form.remarks : ""}
                  onChange={handleChange}
                  span={3}
                  disabled
                />
              </div>
            </Section>
          </div>

          <footer className="sd-form-footer">
            <button
              type="button"
              className="sd-cancel"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>

            <button type="submit" className="sd-save" disabled={saving}>
              <FaSave />{" "}
              {saving ? "Saving..." : isEdit ? "Update Demand" : "Save Demand"}
            </button>
          </footer>
        </form>

        {showUpdateConfirm && (
          <div
            className="sd-confirm-backdrop"
            role="presentation"
            onMouseDown={(event) => {
              if (event.target === event.currentTarget && !saving)
                setShowUpdateConfirm(false);
            }}
          >
            <section
              className="sd-confirm-card"
              role="dialog"
              aria-modal="true"
              aria-labelledby="sd-confirm-title"
            >
              <h3 id="sd-confirm-title">Confirm Demand Update</h3>

              <p>
                Are you sure you want to update this procurement entry
                {data?.file_number ? ` (${data.file_number})` : ""}? The changes
                will be saved to the backend.
              </p>

              <div className="sd-confirm-actions">
                <button
                  type="button"
                  className="sd-cancel"
                  onClick={() => setShowUpdateConfirm(false)}
                  disabled={saving}
                >
                  Review Again
                </button>

                <button
                  type="button"
                  className="sd-confirm-update"
                  onClick={saveDemand}
                  disabled={saving}
                >
                  {saving ? "Updating..." : "Yes, Update"}
                </button>
              </div>
            </section>
          </div>
        )}
      </div>
    </>
  );
}
